<template>
    <input
        :id="question.label"
        type="number"
        class="form_control"
        :placeholder="question.placeholder"
        @input="$emit('input', Number($event.target.value))"
    />
</template>

<script>
export default {
    props: {
        question: {
            type: Object,
            required: true
        }
    }
};
</script>
